let currentSessionId = null;
let refreshPromise = null;

/**
 * @description Saves the session ID and dispatches an event so React UI can update live
 */
export const setIapTokenService = (sessionId) => {
 currentSessionId = sessionId;
 if (sessionId) {
  sessionStorage.setItem('api_session_id', sessionId);
  window.dispatchEvent(new CustomEvent('session-updated', { detail: sessionId })); 
 } else {
  sessionStorage.removeItem('api_session_id');
  window.dispatchEvent(new CustomEvent('session-updated', { detail: null })); 
 }
};

/**
 * @description Explicitly hits the backend refresh endpoint for the given Session ID
 */
export async function explicitTokenRefresh(sid) {
 if (refreshPromise) return refreshPromise; // Prevent concurrent refresh calls
 
 refreshPromise = (async () => {
  try {
   // const response = await fetch(`/api/auth/refresh?sid=${sid}`, {
    const response = await fetch(`/api/auth/refresh`, {  
    method: 'POST',
    headers: { 
        'Content-Type': 'application/json' ,
        'X-Proxy-Auth-Session': sid
    }
   });
   
   if (!response.ok) throw new Error('Refresh failed');
   // ✅ CRITICAL FIX: Capture the newly rotated encrypted session string
   const data = await response.json();
   if (data.new_sid) {
    setIapTokenService(data.new_sid);
   }
   
   return true;
  } finally {
   refreshPromise = null;
  }
 })();
 
 return refreshPromise;
}

/**
 * @description Wrapper for fetch that automatically intercepts 401s and refreshes explicitly
 */
export async function fetchWithIap(url, options = {}, isRetry = false) {
 const sid = currentSessionId || sessionStorage.getItem('api_session_id');
 
 // Inject ?sid=... into the URL. No Headers used!
//  const finalUrl = sid ? `${url}${url.includes('?') ? '&' : '?'}sid=${sid}` : url;

//  let response = await fetch(finalUrl, options);

  // ✅ 2. We preserve ALL existing headers your app sends (like your Chat Session ID)
 const headers = { ...options.headers };
 
 // ✅ 3. We inject ONLY the Proxy Auth Session ID into its own dedicated header
 if (sid) {
  headers['X-Proxy-Auth-Session'] = sid; 
 }

 let response = await fetch(url, { ...options, headers });   
 // INTERCEPTOR: If proxy tells us the token expired, refresh explicitly!
 if (response.status === 401 && !isRetry && sid) {
  const errorData = await response.json().catch(() => ({}));

  if (errorData.error === 'TOKEN_EXPIRED') {
   console.log("Token expired. Explicitly calling /refresh API...");
   try {
    await explicitTokenRefresh(sid);
    
    // Retry the exact same request. The server now has a fresh JWT mapped to our sid.
    response = await fetch(finalUrl, options);
   } catch (refreshErr) {
    console.error("Refresh failed. User must log in again.");
    setIapTokenService(null);
    const error = new Error('SESSION_EXPIRED');
    error.status = 401;
    throw error;
   }
  } else {
   // Session is entirely invalid or dead
   setIapTokenService(null);
   const error = new Error('SESSION_INVALID');
   error.status = 401;
   throw error;
  }
 }

 if (response.status === 401) {
  setIapTokenService(null);
  const error = new Error('SESSION_INVALID');
  error.status = 401;
  throw error;
 }

 if (response.status === 504) {
  const error = new Error('Request Timed Out');
  error.status = 504;
  throw error;
 }

 return response;
}


// let customIapToken = null;
// let refreshPromise = null;

// /**
//  * @description Saves the custom token and dispatches an event so React UI can update live
//  */
// export const setIapTokenService = (token) => {
//  customIapToken = token;
//  if (token) {
//   sessionStorage.setItem('custom_iap_token', token);
//   // Tell React the token changed
//   window.dispatchEvent(new CustomEvent('token-updated', { detail: token })); 
//  } else {
//   sessionStorage.removeItem('custom_iap_token');
//  }
// };

// /**
//  * @description Silently calls the backend to exchange an expired token for a new one
//  */
// export async function silentTokenRefresh(oldToken) {
//  if (refreshPromise) return refreshPromise; // Prevent multiple concurrent refreshes
 
//  refreshPromise = (async () => {
//   try {
//    const response = await fetch('/api/auth/refresh', {
//     method: 'POST',
//     headers: { 'authorization': oldToken, 'Content-Type': 'application/json' }
//    });
   
//    if (!response.ok) throw new Error('Refresh failed');
   
//    const data = await response.json();
//    setIapTokenService(data.token);
//    return data.token;
//   } finally {
//    refreshPromise = null;
//   }
//  })();
 
//  return refreshPromise;
// }

// /**
//  * @description Wrapper for fetch that automatically intercepts 401s and refreshes the token
//  */
// export async function fetchWithIap(url, options = {}, isRetry = false) {
//  let token = customIapToken || sessionStorage.getItem('custom_iap_token');
 
//  const headers = { 
//   ...options.headers, 
//   'X-Requested-With': 'XMLHttpRequest' 
//  };

//  //if (token) headers['authorization'] = token; 

//  const finalOptions = { ...options, headers };
//  let response = await fetch(url, finalOptions);

//  // INTERCEPTOR: If token expired, catch the 401 and refresh silently!
//  if (response.status === 401 && !isRetry && token) {
//   console.log("Token expired. Pausing request and attempting silent refresh...");
//   try {
//    const newToken = await silentTokenRefresh(token);
   
//    // Replay the original API call with the NEW token
//    headers['authorization'] = newToken;
//    response = await fetch(url, { ...options, headers });
//   } catch (refreshErr) {
//    console.error("Silent refresh failed. User must log in again.");
//    setIapTokenService(null);
//    const error = new Error('SESSION_EXPIRED');
//    error.status = 401;
//    throw error;
//   }
//  }

//  if (response.status === 401) {
//   setIapTokenService(null);
//   const error = new Error('SESSION_EXPIRED');
//   error.status = 401;
//   throw error;
//  }

//  if (response.status === 504) {
//   const error = new Error('Request Timed Out');
//   error.status = 504;
//   throw error;
//  }

//  return response;
// }

// // Global state to prevent concurrent refresh attempts
// let isRefreshing = false;
// let refreshPromise = null;

// // Store the Mac token in memory so the fetch function can access it
// let customIapToken = null;

// /**
//  * @description Saves the custom Mac token into memory and sessionStorage
//  * @param {string} token - The 12-hour JWT token
//  */
// export const setIapTokenService = (token) => {
//   customIapToken = token;
//   if (token) {
//     sessionStorage.setItem('custom_iap_token', token);
//   } else {
//     sessionStorage.removeItem('custom_iap_token');
//   }
// };

// /**
//  * @description Executes IAP session refresh using a popup window and verifies success via polling.
//  * NOTE: This is ONLY used for Windows/Web browser cookie-based refreshes.
//  * @returns {Promise<void>} A promise that resolves only when the session is confirmed active.
//  */
// function executeIapRefreshFlow() {
//   const functionName = 'executeIapRefreshFlow';

//   if (isRefreshing) {
//     logger.info('IAP refresh already in progress. Reusing existing promise.', { functionName });
//     return refreshPromise;
//   }

//   isRefreshing = true;
//   window.dispatchEvent(new Event('iap-refresh-start'));
//   logger.info('Starting IAP refresh flow using popup.', { functionName });
//   const securePath = '/api/auth/health';

//   refreshPromise = new Promise((resolve, reject) => {
//     const TOTAL_TIMEOUT_MS = 60000;
//     let poller;
//     let popup;

//     const cleanup = () => {
//       clearInterval(poller);
//       clearTimeout(totalTimeoutTimer);
//       if (popup && !popup.closed) popup.close();
//       isRefreshing = false;
//       refreshPromise = null;
//       window.dispatchEvent(new Event('iap-refresh-end'));
//     };

//     const checkSession = async () => {
//       try {
//         const response = await fetch(securePath, {
//           method: 'GET',
//           credentials: 'include',
//           headers: { 'X-Requested-With': 'XMLHttpRequest' },
//           cache: 'no-store'
//         });

//         if (response.status !== 401) {
//           logger.info('Polling successful. IAP session is now active.', { functionName: 'checkSession' });
//           cleanup();
//           resolve();
//         }
//       } catch (error) {
//         logger.warn('Polling request failed, will retry.', { functionName: 'checkSession', originalError: error });
//       }
//     };

//     const totalTimeoutTimer = setTimeout(() => {
//       logger.error('IAP session refresh timed out.', { functionName, context: { timeout: TOTAL_TIMEOUT_MS } });
//       cleanup();
//       reject(new Error(`IAP session refresh timed out after ${TOTAL_TIMEOUT_MS / 1000} seconds.`));
//     }, TOTAL_TIMEOUT_MS);

//     // Keep it as a hidden off-screen popup for Windows/Web
//     const offScreenLeft = window.screen.width + 100;
//     const offScreenTop = window.screen.height + 100;
//     const popupFeatures = `width=1,height=1,left=${offScreenLeft},top=${offScreenTop}`;
    
//     popup = window.open(`${securePath}?gcp-iap-mode=DO_SESSION_REFRESH`, 'iap_refresh', popupFeatures);

//     if (!popup || popup.closed || typeof popup.closed === 'undefined') {
//       logger.error('Popup window for session refresh was blocked.', { functionName });
//       cleanup();
//       return reject(new Error('Popup window was blocked. Please allow popups for this site.'));
//     }

//     logger.info('Popup opened. Starting polling to verify session.', { functionName });
//     poller = setInterval(checkSession, 2000);
//   });

//   return refreshPromise;
// }

// /**
//  * @description A wrapper for fetch that automatically handles Windows Cookies OR Mac Tokens dynamically.
//  * @param {string} url - The API endpoint to call.
//  * @param {object} options - The options object for the fetch call.
//  * @param {boolean} [isRetry=false] - Internal flag to prevent infinite retry loops.
//  * @returns {Promise<Response>} A promise that resolves with the final API response.
//  */
// export async function fetchWithIap(url, options = {}) {
//   // Grab the 12-hour token
//   const token = customIapToken || sessionStorage.getItem('custom_iap_token');
  
//   const headers = { 
//     ...options.headers, 
//     'X-Requested-With': 'XMLHttpRequest' 
//   };

//   // Attach the token for BOTH Windows and Mac!
//   if (token) {
//     //headers['x-custom-jwt-token'] = token;
//     headers['authorization'] = token;  
//   }

//   const finalOptions = {
//     ...options,
//     headers,
//     // We no longer need credentials: 'include' because we aren't using cookies!
//   };

//   const response = await fetch(url, finalOptions);

//   if (response.status === 504) {
//     const error = new Error('Request Timed Out: The server is taking too long to respond.');
//     error.status = 504;
//     throw error;
//   }

//   if (response.status === 401) {
//     // 401 means the 12-hour token naturally expired. Force re-login.
//     setIapTokenService(null); 
//     const error = new Error('SESSION_EXPIRED');
//     error.status = 401;
//     throw error;
//   }

//   return response;
// }
